import { SessionStatusEvent } from './constants';
import AnalyticsEvent from './AnalyticsEvent';

class SessionStatus extends AnalyticsEvent {
	constructor(userInput, userId, device, isLocalAnalyticsEvent, isGoogleAnalyticsVisit, isGoogleAnalyticsEvent) {
		super(userInput, userId, device, isLocalAnalyticsEvent, isGoogleAnalyticsVisit, isGoogleAnalyticsEvent);
		this.className = 'SessionStatusEvent';
		this.dbDest = 'session_status';
		this.SESSION_HTML_ERROR = '';
		this.SESSION_STARTED = '';
		this.SESSION_COM_ERROR = '';
		this.SESSION_VIEW_LOADED = '[view]_Active';
		this._view = '';
		this._state = '';
		this._duration = -1;
		this._buttonLocation = '';
		this._questions = '';
	}

	appendBaseParams(uId, d) {
		this.append(uId, d);
	}

	appendOptionParams() {
		switch (this.simulatedURL) {
			case SessionStatusEvent.GESTURE_RESPONSE:
				this.extraParams += '&response=' + this.response;
				break;
		}
	}

}

Object.defineProperty(SessionStatus.prototype, 'gaEventSet', {
	get: function () {
		let urlComps = this.simulatedURL.split('_');
		this._gaEventSet.category = urlComps[0];
		this._gaEventSet.action = urlComps[1];
		this._gaEventSet.label = urlComps[2];
		urlComps.length > 3 ? this._gaEventSet.value = urlComps[4] : null;
		return this._gaEventSet;
	}
});

Object.defineProperty(SessionStatus.prototype, 'duration', {
	set: function (tcode) {
		this._duration = tcode;
		this.simulatedURL = this.simulatedURL.replace('[duration]', this._duration);
	},
	get: function () { return this._duration; }
});

Object.defineProperty(SessionStatus.prototype, 'questions', {
	set: function (questions) {
		this._questions = questions;
		this.simulatedURL = this.simulatedURL.replace('[duration]', this._questions);
	},
	get: function () { return this._questions; }
});

Object.defineProperty(SessionStatus.prototype, 'type', {
	set: function (type) {
		this._type = this.ucfirst(type);
		this.simulatedURL = this.simulatedURL.replace('[type]', this._type);
	},
	get: function () { return this._type; }
});

Object.defineProperty(SessionStatus.prototype, 'buttonLocation', {
	set: function (btn) {
		this._buttonLocation = this.ucfirst(btn);
		this.simulatedURL = this.simulatedURL.replace('[buttonLocation]', this._buttonLocation);
	},
	get: function () { return this._buttonLocation; }
});

Object.defineProperty(SessionStatus.prototype, 'state', {
	set: function (state) {
		this._state = this.ucfirst(state);
		this.simulatedURL = this.simulatedURL.replace('[state]', this._state);
	},
	get: function () { return this._state; }
});

Object.defineProperty(SessionStatus.prototype, 'view', {
	set: function (view) {

		let updateViewName = (view) ? this.ucfirst(view) : 'StillLoading';
		switch (view) {
			case ('app_main_view'):
				updateViewName = 'BrowseLibraryView';
				break;

			case ('myshows_view'):
				updateViewName = 'MyLibraryView';
				break;
		}
		this._view = updateViewName;
		this.simulatedURL = this.simulatedURL.replace('[view]', this._view);
	},
	get: function () { return this._view; }
});


export default SessionStatus;


// WEBPACK FOOTER //
// ./src/analytics/analytics-events/SessionStatus.js